export class Microsoft365UserRestoreSelection {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "sourceUserId",
            "baseName": "sourceUserId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return Microsoft365UserRestoreSelection.attributeTypeMap;
    }
    constructor() {
    }
}
